import { STORAGE_KEY } from './mutations'
// import createLogger from '../../../src/plugins/logger'

const localStoragePlugin = store => {
  store.subscribe((mutation, { todos }) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(todos))
  })
}

export default process.env.NODE_ENV !== 'production'
  // ? [createLogger(), localStoragePlugin]
  ? [localStoragePlugin]
  : [localStoragePlugin]



// WEBPACK FOOTER //
// ./src/store/plugins.js